import { instance } from "./instance";
import { BannersResponse, CategoriesResponse, GenresResponse, StatesResponse, CitiesResponse, SocialMediaResponse, MetadataResponse } from "../types/index.d";

const axios = instance("MASTER");

export const getBanners = async (page: string, stationId: string): Promise<BannersResponse> => {
  const response = await axios.get<BannersResponse>(`banner?bannerPage=${page}&stationId=${stationId}`);
  return response.data;
};

export const getGenres = async (): Promise<GenresResponse> => {
  const response = await axios.get<GenresResponse>(`master/genre`);
  return response.data;
};

export const getCategories = async (): Promise<CategoriesResponse> => {
  const response = await axios.get<CategoriesResponse>(`master/talent-hunt-category`);
  return response.data;
};

export const getStates = async (queryParams: { isAll: boolean } = { isAll: false }): Promise<StatesResponse> => {
  const response = await axios.get<StatesResponse>(`master/state?isAll=${queryParams.isAll}`);
  return response.data;
};

export const getCities = async (queryParams: { stateId: string,isAll:boolean }): Promise<CitiesResponse> => {
  const response = await axios.get<CitiesResponse>(`master/city?stateId=${queryParams.stateId}`);
  return response.data;
};

export const getSocialMedia = async (): Promise<SocialMediaResponse> => {
  const response = await axios.get<SocialMediaResponse>(`master/platform`);
  return response.data;
};

export const getMetadata = async (): Promise<MetadataResponse> => {
  const response = await axios.get<MetadataResponse>(`master/config`);
  return response.data;
};